"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = omit;
/**
 * Simple omit function. Removes keys from an object.
 *
 * @param {object} object Source object.
 * @param {array} keys Keys to omit from object.
 */
function omit(object, keys) {
  var ret = {};
  for (var key in object) {
    // eslint-disable-next-line no-prototype-builtins
    if (object.hasOwnProperty(key) && !keys.includes(key)) {
      ret[key] = object[key];
    }
  }
  return ret;
}